import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi, setTitle, consoleLog} from '../../utils/functions';
import {UserContext, TestService} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
//import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../components/fontawesome/fontawesome';
//import CopyBox from '../components/bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';
import { createReactEditorJS } from 'react-editor-js';
import DiscordMessage from '../components/discord/discord';


import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ButtonGroup } from 'react-bootstrap';

//import './css/index.css';
//import './css/header.css';

const ReactEditorJS = createReactEditorJS();

class PortalAdminTwitch extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				name: '',
			},
      type: [
        {name: 'Welcome In Message: Display a welcome in message or to trigger welcome in graphics when listener posts first message.', placeholder: '!w @name', type: 0, save: false},
        {name: 'Train Start: Display a message to initiate the hype train has started', placeholder: 'Hype train started, lets go', type: 1, save: false},
        {name: 'Train End: Display a message thanking everyone for contributing towards the channel', placeholder: 'End of the line! Thank you so much for your fantastic support!', type: 2, save: false},
        {name: 'Following: Personalise a thank you message for following the channel', placeholder: 'Thank you @name, your support is much appreciated to help the channel grow', type: 3, save: false},
        {name: 'Stream Start: Display custom message when the streamer starts streaming', placeholder: '@streamer is now live', type: 4, save: false},
      ],
      messages: [],
      disabled: true,
		};
		this.getTwitch = this.getTwitch.bind(this);
    this.messageChange = this.messageChange.bind(this);
    this.messageAdd = this.messageAdd.bind(this);
    this.messageStatus = this.messageStatus.bind(this);
    this.messageDelete = this.messageDelete.bind(this);
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		//let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', y);

		this.getTwitch();

	}

	componentWillUnmount() {
	}


	async getTwitch() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${this.context.worker[this.props.service]}/v3/admin/twitch`, params);

		consoleLog(x.data);
		//this.setState({status: true, platforms: x.data.platforms, services: x.data.services});
		let service = this.state.service;
		if( x.status === 200 ) {
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.status = true;
				this.setState({service});
				setTitle('Twitch', x.data.servicename);
			}

      let messages = this.state.messages;
      for( let i in x.data.messages ) {
        let find = messages.find(elem => elem.id === x.data.messages[i].id);
        if( find ) {
          if( find.id === this.state.disabled ) {
            find.enabled = x.data.messages[i].enabled;
            find.message = x.data.messages[i].message;
            find.save = false;
          }
        } else {
          messages.push(x.data.messages[i]);
        }
        find = null;
      }
			this.setState({messages, disabled: false});
		}
	}

  async messageChange(id) {
    try {
      let content = id.split('-');
      let message = document.getElementById(id).value;
      if( content[0] === 'm' ) {
        let type = this.state.type;
        type[content[1]].save = message.length > 0 ? true : false;
        this.setState({type});
      } else {
        let messages = this.state.messages;
        let _message = messages.find(elem => elem.id === parseInt(content[1]));
        if( _message ) {
          _message.save = _message.message === message ? false : true;
        }
        this.setState({messages});
      }
    } catch(error) {
      console.log(error);
    }
  }

	async messageAdd(id) {
    try {
      let content = id.split('-');
      let message = document.getElementById(id).value;
      if( message.length === 0 ) return;
      this.setState({disabled: parseInt(content[1])}, async()=>{
        if( content[1] < 10 ) {
          document.getElementById(id).value = '';
        }
        let params = new URLSearchParams();
        params.append('service', this.state.service.id);
        params.append('type', content[1]);
        if( content[1] < 10 ) {
          params.append('enabled', 1);
        } else {
          let _message = this.state.messages;
          let find = _message.find(elem => elem.id === parseInt(content[1]));
          params.append('enabled', find.enabled);
          _message = find = null;
        }
        params.append('message', message);
        await putApi(`${this.context.worker[this.props.service]}/v3/admin/twitch`, params);
        await this.getTwitch();
      });
    } catch(error) {
      console.log(error);
    }
  }


  async messageStatus(id) {
    try {
      let content = id.split('-');
      let messages = this.state.messages;
      let find = messages.find(elem => elem.id === parseInt(content[1]));
      find.enabled = find.enabled === 1 ? 0 : 1;
      this.setState({messages}, async()=>{
        messages = null;
        await this.messageAdd(id);
      });
    } catch(error) {
      console.log(error);
    }
  }


  async messageDelete(id) {
    try {
      let content = id.split('-');
      this.setState({disabled: parseInt(content[1])}, async()=>{
        let params = new URLSearchParams();
        params.append('service', this.state.service.id);
        params.append('type', content[1]);
        await deleteApi(`${this.context.worker[this.props.service]}/v3/admin/twitch`, params);
        let messages = this.state.messages;
        messages = null;
        this.setState({messages: []}, async ()=>{
          await this.getTwitch();
        });
      });
    } catch(error) {
      console.log(error);
    }
  }


	render() {
		const user = this.context;

		const type = this.state.type.map((e,i) => {
			return (
        <div key={i}>
          <div className="d-flex ">
            <span className="ms-2 pt-1">
              {e.name}
            </span>
          </div>
          <ul className="list-group list-group-flush ms-2">
            {this.state.messages.filter(elem => elem.type === e.type).map((f,j) => {
              return (
                <li key={j} className="list-group-item fw-semibold">
                  <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                    <input type="text" className="form-control" placeholder={e.placeholder} style={{width: 300}} id={`n-${f.id}`} defaultValue={f.message} onChange={()=>this.messageChange(`n-${f.id}`)} />
                    
                    {f.save === true &&
                      <Button size="sm" variant="success" onClick={()=>this.messageAdd(`n-${f.id}`)} disabled={this.state.disabled}><FontAwesomeIcon icon="check" /></Button>
                    }
                    <Button size="sm" variant="danger" disabled={this.state.disabled} onClick={()=>this.messageDelete(`n-${f.id}`)}><FontAwesomeIcon icon="trash" /></Button>
                    
                  </div>
                  <Button size="sm" variant="light" onClick={()=>{this.messageStatus(`n-${f.id}`)}}>
                    <div className={`toggle toggle-success ${f.enabled===1?'on':''} mb-0 ms-0`}> 
                      <span></span> 
                    </div>
                  </Button>
                </li>
              )
            })}
            <li className="list-group-item fw-semibold">
              <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                <input type="text" className="form-control" placeholder={e.placeholder} style={{width: 300}} id={`m-${i}`} onChange={()=>this.messageChange(`m-${i}`)} />
                {e.save === true &&
                  <Button size="sm" variant="success" onClick={()=>this.messageAdd(`m-${i}`)} disabled={this.state.disabled}><FontAwesomeIcon icon="add" /></Button>
                }
              </div>
            </li>
          </ul>
        </div>
      )
    });


		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Twitch</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.service.status === true &&
					<div className="main-content app-content">
						<div className="container-fluid">
							<Row>
								<Col lg={12}>
                  <div className="card custom-card">
										<div className="card-header p-0">
											<div className="d-flex p-3 ">
												<div className="">
													<svg className="me-4  bg-success-transparent  alt-notify" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#75cfa5" d="m20.34 9.32-13.99-7a3 3 0 0 0-4.08 3.9L4.41 11l.26.59a1.06 1.06 0 0 1 0 .82l-.26.59-2.14 4.78a2.954 2.954 0 0 0 .67 3.38A2.966 2.966 0 0 0 5 22a3.141 3.141 0 0 0 1.35-.32l13.99-7a2.993 2.993 0 0 0 0-5.36Z"></path><path fill="#198754" d="M14.46 12a.997.997 0 0 1-1 1H4.41l.26-.59a1.06 1.06 0 0 0 0-.82L4.41 11h9.05a.997.997 0 0 1 1 1Z"></path></svg>
												</div>
												<div className="mt-0 text-start">
													<span className="fs-14 fw-semibold">Twitch</span>
													<p className="fs-13 text-muted mb-0">Define your twitch custom messages</p>
												</div>
                      </div>
                    </div>
										<TestService service={this.state.service.id} worker={user.worker[this.state.service.id]} />
										
                  </div>
                </Col>


								<Col xs={12}>

                  <div className="card custom-card">
                    <div className="card-body">
                      <p>
                        Setup custom messages to be display in your twitch chats.<br />
                        You may have multiple statements for each segment and the system will randomly select which message to display.<br />
                        It may take upto an hour to see changes in the chats
                      </p>
                      {type}
                    </div>
                  </div>

                </Col>
								
								
									
							</Row>
						</div>
					</div>
				}
			</>
		);
	}
}

const Twitch = props => {
  const { service } = useParams();
  return <PortalAdminTwitch service={service} {...props} />
}
export default Twitch;